var map = {
	"./USD.svg": [
		"./src/assets/icons/networks/USD.svg",
		"src_assets_icons_networks_USD_svg"
	],
	"./akash.svg": [
		"./src/assets/icons/networks/akash.svg",
		"src_assets_icons_networks_akash_svg"
	],
	"./arbitrum.svg": [
		"./src/assets/icons/networks/arbitrum.svg",
		"src_assets_icons_networks_arbitrum_svg"
	],
	"./archway.svg": [
		"./src/assets/icons/networks/archway.svg",
		"src_assets_icons_networks_archway_svg"
	],
	"./avalanche.svg": [
		"./src/assets/icons/networks/avalanche.svg",
		"src_assets_icons_networks_avalanche_svg"
	],
	"./axelar.svg": [
		"./src/assets/icons/networks/axelar.svg",
		"src_assets_icons_networks_axelar_svg"
	],
	"./band.svg": [
		"./src/assets/icons/networks/band.svg",
		"src_assets_icons_networks_band_svg"
	],
	"./berachain.svg": [
		"./src/assets/icons/networks/berachain.svg",
		"src_assets_icons_networks_berachain_svg"
	],
	"./bitsong.svg": [
		"./src/assets/icons/networks/bitsong.svg",
		"src_assets_icons_networks_bitsong_svg"
	],
	"./bsc.svg": [
		"./src/assets/icons/networks/bsc.svg",
		"src_assets_icons_networks_bsc_svg"
	],
	"./bsc_xct.svg": [
		"./src/assets/icons/networks/bsc_xct.svg",
		"src_assets_icons_networks_bsc_xct_svg"
	],
	"./btc.svg": [
		"./src/assets/icons/networks/btc.svg",
		"src_assets_icons_networks_btc_svg"
	],
	"./calendar.svg": [
		"./src/assets/icons/networks/calendar.svg",
		"src_assets_icons_networks_calendar_svg"
	],
	"./celestia.svg": [
		"./src/assets/icons/networks/celestia.svg",
		"src_assets_icons_networks_celestia_svg"
	],
	"./cerberus.svg": [
		"./src/assets/icons/networks/cerberus.svg",
		"src_assets_icons_networks_cerberus_svg"
	],
	"./checkmark-disabled.svg": [
		"./src/assets/icons/networks/checkmark-disabled.svg",
		"src_assets_icons_networks_checkmark-disabled_svg"
	],
	"./checkmark.svg": [
		"./src/assets/icons/networks/checkmark.svg",
		"src_assets_icons_networks_checkmark_svg"
	],
	"./cheqd.svg": [
		"./src/assets/icons/networks/cheqd.svg",
		"src_assets_icons_networks_cheqd_svg"
	],
	"./chihuahua.svg": [
		"./src/assets/icons/networks/chihuahua.svg",
		"src_assets_icons_networks_chihuahua_svg"
	],
	"./citadel.svg": [
		"./src/assets/icons/networks/citadel.svg",
		"src_assets_icons_networks_citadel_svg"
	],
	"./citadel1.svg": [
		"./src/assets/icons/networks/citadel1.svg",
		"src_assets_icons_networks_citadel1_svg"
	],
	"./coins.svg": [
		"./src/assets/icons/networks/coins.svg",
		"src_assets_icons_networks_coins_svg"
	],
	"./comdex.svg": [
		"./src/assets/icons/networks/comdex.svg",
		"src_assets_icons_networks_comdex_svg"
	],
	"./coreum.svg": [
		"./src/assets/icons/networks/coreum.svg",
		"src_assets_icons_networks_coreum_svg"
	],
	"./cosmos.svg": [
		"./src/assets/icons/networks/cosmos.svg",
		"src_assets_icons_networks_cosmos_svg"
	],
	"./crescent.svg": [
		"./src/assets/icons/networks/crescent.svg",
		"src_assets_icons_networks_crescent_svg"
	],
	"./curve-arrow.svg": [
		"./src/assets/icons/networks/curve-arrow.svg",
		"src_assets_icons_networks_curve-arrow_svg"
	],
	"./dydx.svg": [
		"./src/assets/icons/networks/dydx.svg",
		"src_assets_icons_networks_dydx_svg"
	],
	"./emoney.svg": [
		"./src/assets/icons/networks/emoney.svg",
		"src_assets_icons_networks_emoney_svg"
	],
	"./error.svg": [
		"./src/assets/icons/networks/error.svg"
	],
	"./eth.svg": [
		"./src/assets/icons/networks/eth.svg",
		"src_assets_icons_networks_eth_svg"
	],
	"./evmos.svg": [
		"./src/assets/icons/networks/evmos.svg",
		"src_assets_icons_networks_evmos_svg"
	],
	"./evmoseth.svg": [
		"./src/assets/icons/networks/evmoseth.svg",
		"src_assets_icons_networks_evmoseth_svg"
	],
	"./fetch.svg": [
		"./src/assets/icons/networks/fetch.svg",
		"src_assets_icons_networks_fetch_svg"
	],
	"./gbridge.svg": [
		"./src/assets/icons/networks/gbridge.svg",
		"src_assets_icons_networks_gbridge_svg"
	],
	"./hardware-dot.svg": [
		"./src/assets/icons/networks/hardware-dot.svg",
		"src_assets_icons_networks_hardware-dot_svg"
	],
	"./hide.svg": [
		"./src/assets/icons/networks/hide.svg"
	],
	"./icon.svg": [
		"./src/assets/icons/networks/icon.svg",
		"src_assets_icons_networks_icon_svg"
	],
	"./info.svg": [
		"./src/assets/icons/networks/info.svg"
	],
	"./injective.svg": [
		"./src/assets/icons/networks/injective.svg",
		"src_assets_icons_networks_injective_svg"
	],
	"./iost.svg": [
		"./src/assets/icons/networks/iost.svg",
		"src_assets_icons_networks_iost_svg"
	],
	"./iris.svg": [
		"./src/assets/icons/networks/iris.svg",
		"src_assets_icons_networks_iris_svg"
	],
	"./jackal.svg": [
		"./src/assets/icons/networks/jackal.svg",
		"src_assets_icons_networks_jackal_svg"
	],
	"./juno.svg": [
		"./src/assets/icons/networks/juno.svg",
		"src_assets_icons_networks_juno_svg"
	],
	"./kava.svg": [
		"./src/assets/icons/networks/kava.svg",
		"src_assets_icons_networks_kava_svg"
	],
	"./keplr-dot.svg": [
		"./src/assets/icons/networks/keplr-dot.svg",
		"src_assets_icons_networks_keplr-dot_svg"
	],
	"./key.svg": [
		"./src/assets/icons/networks/key.svg",
		"src_assets_icons_networks_key_svg"
	],
	"./kichain.svg": [
		"./src/assets/icons/networks/kichain.svg",
		"src_assets_icons_networks_kichain_svg"
	],
	"./konstellation.svg": [
		"./src/assets/icons/networks/konstellation.svg",
		"src_assets_icons_networks_konstellation_svg"
	],
	"./kujira.svg": [
		"./src/assets/icons/networks/kujira.svg",
		"src_assets_icons_networks_kujira_svg"
	],
	"./lang.svg": [
		"./src/assets/icons/networks/lang.svg",
		"src_assets_icons_networks_lang_svg"
	],
	"./lava.svg": [
		"./src/assets/icons/networks/lava.svg",
		"src_assets_icons_networks_lava_svg"
	],
	"./leap-dot.svg": [
		"./src/assets/icons/networks/leap-dot.svg",
		"src_assets_icons_networks_leap-dot_svg"
	],
	"./lock.svg": [
		"./src/assets/icons/networks/lock.svg",
		"src_assets_icons_networks_lock_svg"
	],
	"./loop.svg": [
		"./src/assets/icons/networks/loop.svg",
		"src_assets_icons_networks_loop_svg"
	],
	"./lum.svg": [
		"./src/assets/icons/networks/lum.svg",
		"src_assets_icons_networks_lum_svg"
	],
	"./mail.svg": [
		"./src/assets/icons/networks/mail.svg"
	],
	"./mantle.svg": [
		"./src/assets/icons/networks/mantle.svg",
		"src_assets_icons_networks_mantle_svg"
	],
	"./metamask-dot.svg": [
		"./src/assets/icons/networks/metamask-dot.svg",
		"src_assets_icons_networks_metamask-dot_svg"
	],
	"./nibiru.svg": [
		"./src/assets/icons/networks/nibiru.svg",
		"src_assets_icons_networks_nibiru_svg"
	],
	"./nolus.svg": [
		"./src/assets/icons/networks/nolus.svg",
		"src_assets_icons_networks_nolus_svg"
	],
	"./oasis.svg": [
		"./src/assets/icons/networks/oasis.svg",
		"src_assets_icons_networks_oasis_svg"
	],
	"./omniflix.svg": [
		"./src/assets/icons/networks/omniflix.svg",
		"src_assets_icons_networks_omniflix_svg"
	],
	"./oneseed-dot.svg": [
		"./src/assets/icons/networks/oneseed-dot.svg",
		"src_assets_icons_networks_oneseed-dot_svg"
	],
	"./optimism.svg": [
		"./src/assets/icons/networks/optimism.svg",
		"src_assets_icons_networks_optimism_svg"
	],
	"./orai.svg": [
		"./src/assets/icons/networks/orai.svg",
		"src_assets_icons_networks_orai_svg"
	],
	"./osmosis.svg": [
		"./src/assets/icons/networks/osmosis.svg",
		"src_assets_icons_networks_osmosis_svg"
	],
	"./persistence.svg": [
		"./src/assets/icons/networks/persistence.svg",
		"src_assets_icons_networks_persistence_svg"
	],
	"./polkadot.svg": [
		"./src/assets/icons/networks/polkadot.svg",
		"src_assets_icons_networks_polkadot_svg"
	],
	"./polygon.svg": [
		"./src/assets/icons/networks/polygon.svg",
		"src_assets_icons_networks_polygon_svg"
	],
	"./private-dot.svg": [
		"./src/assets/icons/networks/private-dot.svg",
		"src_assets_icons_networks_private-dot_svg"
	],
	"./provenance.svg": [
		"./src/assets/icons/networks/provenance.svg",
		"src_assets_icons_networks_provenance_svg"
	],
	"./public-dot.svg": [
		"./src/assets/icons/networks/public-dot.svg",
		"src_assets_icons_networks_public-dot_svg"
	],
	"./quasar.svg": [
		"./src/assets/icons/networks/quasar.svg",
		"src_assets_icons_networks_quasar_svg"
	],
	"./quicksilver.svg": [
		"./src/assets/icons/networks/quicksilver.svg",
		"src_assets_icons_networks_quicksilver_svg"
	],
	"./regen.svg": [
		"./src/assets/icons/networks/regen.svg",
		"src_assets_icons_networks_regen_svg"
	],
	"./rizon.svg": [
		"./src/assets/icons/networks/rizon.svg",
		"src_assets_icons_networks_rizon_svg"
	],
	"./saga.svg": [
		"./src/assets/icons/networks/saga.svg",
		"src_assets_icons_networks_saga_svg"
	],
	"./secret.svg": [
		"./src/assets/icons/networks/secret.svg",
		"src_assets_icons_networks_secret_svg"
	],
	"./seedphrase-dot.svg": [
		"./src/assets/icons/networks/seedphrase-dot.svg",
		"src_assets_icons_networks_seedphrase-dot_svg"
	],
	"./sei.svg": [
		"./src/assets/icons/networks/sei.svg",
		"src_assets_icons_networks_sei_svg"
	],
	"./sentinel.svg": [
		"./src/assets/icons/networks/sentinel.svg",
		"src_assets_icons_networks_sentinel_svg"
	],
	"./sifchain.svg": [
		"./src/assets/icons/networks/sifchain.svg",
		"src_assets_icons_networks_sifchain_svg"
	],
	"./solana.svg": [
		"./src/assets/icons/networks/solana.svg",
		"src_assets_icons_networks_solana_svg"
	],
	"./stacks.svg": [
		"./src/assets/icons/networks/stacks.svg",
		"src_assets_icons_networks_stacks_svg"
	],
	"./stafi.svg": [
		"./src/assets/icons/networks/stafi.svg",
		"src_assets_icons_networks_stafi_svg"
	],
	"./stargaze.svg": [
		"./src/assets/icons/networks/stargaze.svg",
		"src_assets_icons_networks_stargaze_svg"
	],
	"./starname.svg": [
		"./src/assets/icons/networks/starname.svg",
		"src_assets_icons_networks_starname_svg"
	],
	"./stride.svg": [
		"./src/assets/icons/networks/stride.svg",
		"src_assets_icons_networks_stride_svg"
	],
	"./sui.svg": [
		"./src/assets/icons/networks/sui.svg",
		"src_assets_icons_networks_sui_svg"
	],
	"./telcoin.svg": [
		"./src/assets/icons/networks/telcoin.svg",
		"src_assets_icons_networks_telcoin_svg"
	],
	"./teritori.svg": [
		"./src/assets/icons/networks/teritori.svg",
		"src_assets_icons_networks_teritori_svg"
	],
	"./tether.svg": [
		"./src/assets/icons/networks/tether.svg",
		"src_assets_icons_networks_tether_svg"
	],
	"./text.svg": [
		"./src/assets/icons/networks/text.svg",
		"src_assets_icons_networks_text_svg"
	],
	"./tez.svg": [
		"./src/assets/icons/networks/tez.svg",
		"src_assets_icons_networks_tez_svg"
	],
	"./trace.svg": [
		"./src/assets/icons/networks/trace.svg",
		"src_assets_icons_networks_trace_svg"
	],
	"./tron.svg": [
		"./src/assets/icons/networks/tron.svg",
		"src_assets_icons_networks_tron_svg"
	],
	"./trueusd.svg": [
		"./src/assets/icons/networks/trueusd.svg",
		"src_assets_icons_networks_trueusd_svg"
	],
	"./umee.svg": [
		"./src/assets/icons/networks/umee.svg",
		"src_assets_icons_networks_umee_svg"
	],
	"./vision.svg": [
		"./src/assets/icons/networks/vision.svg"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/assets/icons/networks lazy recursive ^\\.\\/.*\\.svg$";
module.exports = webpackAsyncContext;